const URL = {
  // Admin editor preview of the Continue learning block. Authenticated; shop comes from the
  // token. Returns the shop's own content with sample progress - a creator has none of their own.
  CONTINUE_LEARNING_ADMIN: 'learning/continue/admin',
}

export default URL
